module.exports = __webpack_public_path__ + "img/Takeaway Pay Icon - white.e52c9b4c.svg";